import { ErrorLayout } from "src/apps/components/errorLayout/ErrorLayout";
import { StandaloneErrorScreen } from "src/apps/components/errorLayout/StandaloneErrorScreen";
import { Avatar } from "src/apps/components/avatar/Avatar";
import { useTheme } from "src/apps/providers/ThemeStore";
import { TEST_IDS } from "src/apps/config/testIds";
import { useErrorFallbackCopy } from "./errorScreenFallbackCopy";

// Rendered by the root ErrorBoundary and by providers above the router, translations and
// customization, so its copy is bundled (see errorScreenFallbackCopy) instead of using Accent keys
export const ErrorScreen = ({ error, isNotFound }: { error?: Error; isNotFound?: boolean }) => {
  const { removeCustomerLogo } = useTheme();
  const copy = useErrorFallbackCopy();

  return (
    <StandaloneErrorScreen>
      <ErrorLayout
        top={!removeCustomerLogo ? <Avatar /> : null}
        heading={copy.title}
        title={error?.message ?? (isNotFound ? copy.notFound : copy.description)}
        dataTestId={TEST_IDS.errorScreen.screen}
        noticeDataTestId={TEST_IDS.errorScreen.notice}
      />
    </StandaloneErrorScreen>
  );
};
